document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.media-gallery-thumbs').forEach(gallery => {
    const genderEls = gallery.querySelectorAll('[data-gender]')
    if (!genderEls.length) return

    const cookieMatch = document.cookie.match(/(?:^|;\s*)personalize=([^;]*)/)
    const cookieValue = cookieMatch ? decodeURIComponent(cookieMatch[1]) : ''
    const mode = (cookieValue === 'women' || cookieValue === 'men') ? cookieValue : 'default'

    // Ungendered slides always stay visible. Only slides explicitly tagged
    // bp-woman/bp-man (data-gender) are filtered against each other based
    // on the visitor's personalization.
    genderEls.forEach(el => {
      const isMatch = mode === 'default' || el.dataset.gender === mode
      el.hidden = !isMatch
      el.classList.toggle('media-gallery-gender--hidden', !isMatch)
    })

    const items = [...gallery.querySelectorAll('.media-gallery__item')]
    const thumbs = [...gallery.querySelectorAll('.media-gallery-thumbs__thumb')]
    if (!items.length || !thumbs.length) return

    // Keep the active item as-is unless it just got hidden — then fall
    // back to the first visible item (the first thumbnail, by default).
    const activeItem = items.find(i => i.classList.contains('active'))
    if (activeItem && !activeItem.hidden) return

    const targetIndex = items.findIndex(i => !i.hidden)
    if (targetIndex === -1) return

    items.forEach(i => i.classList.remove('active'))
    thumbs.forEach(t => t.classList.remove('active'))

    items[targetIndex].classList.add('active')
    thumbs[targetIndex]?.classList.add('active')
  })
})
